import { useEffect, useRef, DependencyList } from 'react';

import { TSFixMe } from '~/src/types';

// Guarantee `func` can only be invoked once, until `deps` change
export const useRunOnlyOnce = <F extends (...args: any[]) => void>(
  func: F,
  deps: DependencyList,
): F => {
  const hasBeenCalledRef = useRef(false);

  useEffect(() => {
    hasBeenCalledRef.current = false;
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  return ((...args: any[]) => {
    if (hasBeenCalledRef.current) return;
    hasBeenCalledRef.current = true;
    return func(...args);
  }) as TSFixMe;
};
